<template>
  <div class="notice-edu-modal">
    <el-dialog :visible.sync="noticeModalVisible" width="380px" :before-close="handleClose" :show-close="false" v-el-drag-dialog :close-on-click-modal='false'>
      <div slot="title" class="notice-modal-title">
        <span class="modal-title-icon">
          <i v-if="noticeType === 1" class="el-icon-warning"></i>
          <i v-if="noticeType === 4" class="el-icon-warning"></i>
          <i v-if="noticeType === 5" class="el-icon-warning"></i>
          <i v-if="noticeType === 2" class="el-icon-error"></i>
          <i v-if="noticeType === 3" class="el-icon-success"></i>
        </span>
        <span class="modal-title-span">{{noticeTitle}}</span>
      </div>
      <div class="notice-modal-content">
        <span v-if="noticeSpec" class="modal-content-spec">{{noticeSpec}}</span>
        <span>{{noticeContent}}</span>
      </div>
      <div slot="footer" class="notice-modal-footer">
        <div v-if="noticeType === 1">
          <el-button class="modal-footer-two" @click="closeNotice">{{btnclose}}</el-button>
          <el-button class="modal-footer-two" type="primary" @click="agreeNotice">{{btnAgree}}</el-button>
          <el-button class="modal-footer-two" type="primary" @click="agreeNoticeTwo" v-if="btnAgreeTwo">{{btnAgreeTwo}}</el-button>
        </div>
        <div v-if="noticeType === 4">
          <el-button class="modal-footer-two" type="primary" @click="closeNotice">直接切换</el-button>
          <el-button class="modal-footer-two" type="primary" @click="agreeNotice">{{btnAgree}}</el-button>
        </div>
        <div v-if="noticeType === 2">
          <el-button class="modal-footer-four" type="primary" @click="agreeNotice">{{btnAgree}}</el-button>
        </div>
        <div v-if="noticeType === 3">
          <el-button class="modal-footer-four" type="primary" @click="agreeNotice">{{btnAgree}}</el-button>
        </div>
        <div v-if="noticeType === 5">
          <el-button class="modal-footer-four" type="primary" @click="agreeNotice">{{btnAgree}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'noticeModal',
  props: {
    noticeType: {
      type: Number,
      default: 1
    }, // 1警告，2错误，3成功
    noticeModalVisible: {
      type: Boolean,
      default: false
    },
    noticeTitle: {
      type: String,
      default: '这是一条警告提示'
    },
    btnclose: {
      type: String,
      default: '取消'
    },
    noticeSpec: {
      type: String,
      default: ''
    },
    noticeContent: {
      type: String,
      default: '此操作将永久删除该文件，是否继续？'
    },
    btnAgree: {
      type: String,
      default: '确定'
    },
    btnAgreeTwo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  methods: {
    // 弹窗关闭
    handleClose() {
      this.$emit('noticeModalClose')
    },
    // 取消
    closeNotice() {
      this.$emit('noticeModalClose')
    },
    // 确定
    agreeNotice() {
      this.$emit('noticeModalAgree')
    },
    // 确定
    agreeNoticeTwo() {
      this.$emit('agreeNoticeTwo')
    }
  }
}
</script>

<style lang="scss">
.notice-edu-modal {
  .el-dialog__header {
    padding: 16px 16px 0 16px;
    font-size: 0;
    .notice-modal-title {
      height: 28px;
      line-height: 28px;
      .modal-title-span{
        padding-left: 8px;
        color: #2E4057;
        font-size: 12px;
        font-weight: bold;
      }
      .modal-title-icon {
        display: inline-block;
        vertical-align: middle;
        .el-icon-warning {
          font-size: 24px;
          color: #FFA941;
        }
        .el-icon-error {
          font-size: 24px;
          color: #FF4D4F;
        }
        .el-icon-success {
          font-size: 24px;
          color: #33cc99;
        }
      }
    }
  }
  .el-dialog__body {
    .notice-modal-content {
      line-height: 28px;
      font-size: 12px;
      color: #2E4057;
      .modal-content-spec {
        color: #FF4D4F;
      }
    }
    padding: 0 16px 16px 48px;
  }
  .el-dialog__footer {
    padding: 16px;
    .notice-modal-footer {
      font-size: 0;
      .modal-footer-two {
        // width: 48px;
        height: 28px;
        margin-left: 8px !important;
      }
      .modal-footer-four {
        // width: 72px;
        height: 28px;
      }
    }
  }
}
</style>
